// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Categories_mainSection__NL5eZ {
  margin: 4rem 0 1rem;
}

.Categories_cards__BsAix {
  display: flex;
  justify-content: space-between;
}

.Categories_card_section__yjcUM {
  width: 100%;

  & img {
    width: 100%;
    height: auto;
  }
}

.Categories_userGrid__2vLf1 {
  width: 100%;
  height: auto;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 40px;

  & li {
    padding-bottom: 6px;
    font-family: Inter;
    font-size: 0.9rem;
    font-weight: 600;
  }
}

.Categories_userCard__-s00D {
  width: 100%;
  height: auto;
  position: relative;

  .Categories_data__yo9xx {
    width: 100%;
    height: auto;
    position: absolute;
    top: 270px;
    left: 0;
    padding-left: 10px;
    background: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.9));

    & p {
      color: var(--text-color);
      font-family: Inter;
      font-size: 0.87rem;
      font-weight: 500;
    }

    & h6 {
      color: var(--text-color);
      font-family: Inter;
      font-size: 1.1rem;
      font-weight: 700;
    }
  }
}

.Categories_userImage__Sm00n {
  width: 100%;
  height: auto;
  margin-bottom: 10px;
}

/* --------media-queries--------- */

@media (max-width: 768px) {
  .Categories_userGrid__2vLf1 {
    grid-template-columns: repeat(2, 1fr);
    gap: 15px;
  }
  .Categories_userCard__-s00D {
    position: relative;

    .Categories_data__yo9xx {
      padding-top: 30px;
      height: 105px;
      position: absolute;
      bottom: 0;
      left: 0;
      background: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.9));
    }
  }

  .Categories_mainSection__NL5eZ {
    margin: 2rem 0 1rem;
  }
}

@media (max-width: 480px) {
  .Categories_userGrid__2vLf1 {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Categories/Categories.module.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,WAAW;;EAEX;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,qCAAqC;EACrC,SAAS;;EAET;IACE,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;EAClB;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;;EAElB;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,OAAO;IACP,kBAAkB;IAClB,iEAAiE;;IAEjE;MACE,wBAAwB;MACxB,kBAAkB;MAClB,kBAAkB;MAClB,gBAAgB;IAClB;;IAEA;MACE,wBAAwB;MACxB,kBAAkB;MAClB,iBAAiB;MACjB,gBAAgB;IAClB;EACF;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA,mCAAmC;;AAEnC;EACE;IACE,qCAAqC;IACrC,SAAS;EACX;EACA;IACE,kBAAkB;;IAElB;MACE,iBAAiB;MACjB,aAAa;MACb,kBAAkB;MAClB,SAAS;MACT,OAAO;MACP,iEAAiE;IACnE;EACF;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".mainSection {\n  margin: 4rem 0 1rem;\n}\n\n.cards {\n  display: flex;\n  justify-content: space-between;\n}\n\n.card_section {\n  width: 100%;\n\n  & img {\n    width: 100%;\n    height: auto;\n  }\n}\n\n.userGrid {\n  width: 100%;\n  height: auto;\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 40px;\n\n  & li {\n    padding-bottom: 6px;\n    font-family: Inter;\n    font-size: 0.9rem;\n    font-weight: 600;\n  }\n}\n\n.userCard {\n  width: 100%;\n  height: auto;\n  position: relative;\n\n  .data {\n    width: 100%;\n    height: auto;\n    position: absolute;\n    top: 270px;\n    left: 0;\n    padding-left: 10px;\n    background: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.9));\n\n    & p {\n      color: var(--text-color);\n      font-family: Inter;\n      font-size: 0.87rem;\n      font-weight: 500;\n    }\n\n    & h6 {\n      color: var(--text-color);\n      font-family: Inter;\n      font-size: 1.1rem;\n      font-weight: 700;\n    }\n  }\n}\n\n.userImage {\n  width: 100%;\n  height: auto;\n  margin-bottom: 10px;\n}\n\n/* --------media-queries--------- */\n\n@media (max-width: 768px) {\n  .userGrid {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 15px;\n  }\n  .userCard {\n    position: relative;\n\n    .data {\n      padding-top: 30px;\n      height: 105px;\n      position: absolute;\n      bottom: 0;\n      left: 0;\n      background: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.9));\n    }\n  }\n\n  .mainSection {\n    margin: 2rem 0 1rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .userGrid {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mainSection": `Categories_mainSection__NL5eZ`,
	"cards": `Categories_cards__BsAix`,
	"card_section": `Categories_card_section__yjcUM`,
	"userGrid": `Categories_userGrid__2vLf1`,
	"userCard": `Categories_userCard__-s00D`,
	"data": `Categories_data__yo9xx`,
	"userImage": `Categories_userImage__Sm00n`
};
export default ___CSS_LOADER_EXPORT___;
